import React from "react";
import CountUp from "react-countup";
import SVGRenderer from "../SVGRenderer";
import SmartLink from "components/SmartLink";
import Button from "components/elements/Button/Button";

import styles from "./Card.module.scss";

/**
 * Card with content overlaid on background image
 * 
 * @param {Object} props - Component properties
 */
const CardOverlay = React.forwardRef(({ 
	inView,
	title, 
	svg, 
	lead, 
	desc, 
	cta_text, 
	cta_link,
	bg_image,
	bg_image_alt,
	bg_color,
	className = "", 
	theme, 
	count_up
}, ref) => {
	return (
		<div
			ref={ref}
			data-bs-theme="dark"
			style={bg_color && { 
				backgroundColor: bg_color,
				backgroundImage: bg_image ? `url(${bg_image})` : undefined,
				backgroundSize: 'cover',
				backgroundPosition: 'center'
			}}
			className={`${styles.CardOverlay} card h-100 rounded-4 shadow border-0 position-relative overflow-hidden ${className}`}>
			<div className="overlay position-absolute w-100 h-100 bg-dark" style={{ opacity: 0.7, zIndex: 1 }}></div>
			<div className="card-body p-4 d-flex flex-column text-white h-100" style={{ zIndex: 2 }}>
				{svg && (
					<div className="mb-3 svg-wrapper">
						<SVGRenderer svgString={svg} />
					</div>
				)}
				{inView && count_up && (
					<CountUp
						className="count-up display-4 fw-bold mb-3"
						end={count_up}
						duration={5}
						separator="."
					/>
				)}
				{title && <h3 className="card-title fs-3 fw-bold mb-2">{title}</h3>}
				{lead && <p className="lead fs-5 mb-3 opacity-75">{lead}</p>}
				
				{desc && (
					<div 
						className="card-text mb-4"
						dangerouslySetInnerHTML={{ __html: desc }}></div>
				)}
				
				<div className="mt-auto">
					{cta_text && cta_link && (
						<SmartLink to={cta_link}>
							<Button
								size={"md"}
								variant={"light"}
								letterCase="uppercase">
								{cta_text}
							</Button>
						</SmartLink>
					)}
				</div>
			</div>
		</div>
	);
});

export default CardOverlay;
